// enums
const USER_ROLE = {
  VIEWER: 0,
  BROADCASTER: 1
};

const EVENTS = {
  JoinRoom: "JoinRoom",
  LeaveRoom: "LeaveRoom",
  IceCandidate: "icecandidate",
  MediaStreamingStartRequest: "MediaStreamingStartRequest",
  MediaStreamingStopRequest: "MediaStreamingStopRequest",
  IceCandidates: "IceCandidates",
  PeerOffer: "PeerOffer",
  PeerAnswer: "PeerAnswer"
};

const PEER_CONNECTION_STATES = {
  New: "new",
  Checking: "checking",
  Connecting: "connecting",
  Connected: "connected",
  Failed: "failed",
  Disconnected: "disconnected",
  Closed: "closed"
};

const CONNECTION_STATES = {
  Connecting: "Connecting",
  Connected: "Connected",
  Disconnected: "Disconnected",
  Closed: "Closed"
};

const SIGNALING_STATES = {
  HaveRemoteOffer: "have-remote-offer"
};

const ICE_CONNECTION_STATES = {
  NEW: "new",
  CHECKING: "checking"
}

const MEDIA_TYPE = {
  WEBCAM: 0,
  SCREENSHARE: 1
};

const AUTHENTICATION_TYPE = {
  SESSION: 0,
  SDK: 1
};

export {
  USER_ROLE,
  EVENTS,
  PEER_CONNECTION_STATES,
  CONNECTION_STATES,
  SIGNALING_STATES,
  ICE_CONNECTION_STATES,
  MEDIA_TYPE,
  AUTHENTICATION_TYPE
};
